import React, { useEffect } from 'react';
import Pagination from '../../../components/Pagination';

const PaginationButtonsLayout = ({
  id,
  header,
  content,
  pageNumber,
  setPageNumber,
  onPageChange,
  hasNextPage,
  hasPreviousPage
}) => {
  useEffect(() => {
    // A postPageChange since the page is not re-rendering after the last page.
    if (hasNextPage !== undefined && !hasNextPage) {
      onPageChange();
    }
  }, [hasNextPage, onPageChange]);

  const changePage = unit => {
    if (onPageChange) {
      onPageChange();
    }
    setPageNumber(page => page + unit);
    window.scrollTo(0, 0);
  };

  return (
    <React.Fragment key={id}>
      {header}
      {hasPreviousPage && (
        <Pagination
          loadPrevPage={() => changePage(-1)}
          loadNextPage={() => changePage(1)}
          hasNextPage={hasNextPage}
          hasPreviousPage={hasPreviousPage}
          pageNumber={pageNumber + 1}
        />
      )}
      {content}
      {(hasPreviousPage || hasNextPage) && (
        <Pagination
          loadPrevPage={() => changePage(-1)}
          loadNextPage={() => changePage(1)}
          hasNextPage={hasNextPage}
          hasPreviousPage={hasPreviousPage}
          pageNumber={pageNumber + 1}
        />
      )}
    </React.Fragment>
  );
};

export default PaginationButtonsLayout;
